import { InputBase, inputBaseClasses, styled } from '@mui/material';
import { map } from 'lodash';
import React from 'react';
import {
  baseSelectStyles,
  getCurrentSelectedOption,
  getNewSelectionValue,
  SelectInput,
  SelectOption,
} from '../rselect/ReactSelectUtils';
import UnsortedSelect from '../rselect/UnsortedSelect';

const NUM_ITEMS_OPTIONS = [25, 50, 100, 200];

const styles = {
  header: {
    fontSize: 10,
    fontWeight: 500,
  },
  pageContainer: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  pageNumber: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginRight: 6,
  },
};

const StyledInputBase = styled(InputBase)((theme) => ({
  marginRight: 4,
  [`.${inputBaseClasses.input}`]: {
    backgroundColor: 'white',
    fontWeight: 400,
    width: 50,
    height: 25,
    paddingRight: 4,
    textAlign: 'right',
    fontSize: 12,
    color: '#273438',
    borderRadius: 4,
    border: '1px solid #ccc',
  },
}));

type Props = {
  page: number;
  totalPages: number;
  itemsPerPage: number;
  itemsPerPageOptions?: number[];
  onChange: (options: { page?: number; size?: number }) => void;
};

const PageNavigation = ({
  page,
  totalPages,
  itemsPerPage,
  itemsPerPageOptions,
  onChange,
}: Props) => {
  const options = map(itemsPerPageOptions || NUM_ITEMS_OPTIONS, (value) => ({
    label: value,
    value,
  }));
  const itemsPerPageOption = getCurrentSelectedOption(options, itemsPerPage as any);

  const handlePageChange = (e) => {
    const page = e.target.value;
    onChange({ page: page });
  };

  const handleSizeChange = (selectedOption) => {
    //TODO: should have a better way of resetting default value
    let size = getNewSelectionValue(selectedOption, true, 100);
    onChange({ size: size });
  };

  return (
    <div className="files-page-container" style={styles.pageContainer}>
      <div style={styles.pageNumber}>
        <div style={styles.header}>{`Page (of: ${totalPages})`}</div>
        <StyledInputBase
          margin="dense"
          type="text"
          inputProps={{
            autoComplete: 'new-password',
          }}
          value={page}
          onChange={handlePageChange}
        />
      </div>
      <div>
        <span style={styles.header}>
          {'  '}Items Per Page{'  '}
        </span>
        <UnsortedSelect
          options={options}
          components={{ Input: SelectInput, Option: SelectOption }}
          isClearable={false}
          isSearchable={true}
          backspaceRemovesValue={false}
          value={itemsPerPageOption}
          onChange={handleSizeChange}
          styles={baseSelectStyles}
        />
      </div>
    </div>
  );
};

export default PageNavigation;
